export default __webpack_public_path__ + "static/media/BLANCO.1a189b79.png";